import { useRouteNode } from 'react-router5';

import ContactView from "./contactView";
import EntityView from "../entities/entityView";
import ThemeView from "../themes/themeView";

import NetworkMap from "../singleView/network_map";

function SetProfil({data, type}){
  // FIXME? this could be used by explore.entity, explore.theme ...
  const { route: {data: data_route} } = useRouteNode('explore.contact');

  let view;
  if(type === "contact"){
    view = <ContactView key={data.id} contact={data} component_route={"explore.contact"} />
  }else if(type === "entity"){
    view = <EntityView key={data.id} entity={data} component_route={"explore.entity"} />
  }else{
    view = <ThemeView key={data.id} theme={data}/>
  }

  const show_network_map = ["contact", "entity"].includes(type);

  return (
    <>
      <div className="c-container_global">
        <section className="c-container container_one"
                 style={{width: show_network_map ? "50%" : "100%"}}>
          { view }
        </section>
        { show_network_map &&
          <section className="c-container container_two" style={{width: "50%"}}>
            <NetworkMap key={`${type}_${data.id}`} type={type} data={data_route} ec={data} />
          </section>
        }
      </div>
    </>

  );
};


export default SetProfil
